<template>
  <div class="bg-nav-bg bg-no-repeat bg-cover w-208 h-266">
    <div class="pl-20 pt-24 w-full flex flex-row">
      <img class="mt-3" :src="`${imgPath}/nav3.png`" />
      <ul class="mt-3">
        <li
          class=" mt-3 ml-5 text-left flex flex-row items-center"
          v-for="(nav, index) in navData"
          :key="index"
        >
          <img
            v-if="nav.anchor.includes(pageNumber + 1)"
            class="absolute left-16"
            :src="`${imgPath}/nav2.png`"
          />
          <span
            @click="moveTo(nav.anchor)"
            :class="
              nav.anchor.includes(pageNumber + 1) ? 'opacity-100' : 'opacity-30'
            "
            class="block font-mulish-regular text-very-soft-orange leading-1.2 tracking-widest cursor-pointer uppercase"
            v-html="nav.title"
          ></span>
        </li>
      </ul>
    </div>
    <div class="w-36 h-36 mx-auto -mt-10 cursor-pointer" @click="moveTo(1)">
      <img class="w-full" :src="`${imgPath}/nav4.png`" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: ['moveTo'],
  data: function() {
    return {
      navData: [
        {
          title: 'Scenario',
          anchor: '3',
        },
        {
          title: 'New Areas',
          anchor: '4',
        },
        {
          title: 'New Monsters',
          anchor: [5, 6],
        },
        {
          title: 'New Champion',
          anchor: '7',
        },
        {
          title: 'New NPCS',
          anchor: '8',
        },
        {
          title: 'System Changes',
          anchor: [9, 10],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>

<style></style>
